import React from "react";
import { motion } from "framer-motion";
import { TID } from "../../lib/testIds";

const CATEGORIES = [
  {
    label: "AI & LLM Engineering",
    items: [
      "OpenAI APIs",
      "Azure AI",
      "LangChain",
      "RAG Architectures",
      "Vector Databases",
      "LLM Orchestration",
      "AI Agents",
    ],
  },
  {
    label: "Frontend",
    items: ["React", "Next.js", "Vue.js", "Angular", "TypeScript"],
  },
  {
    label: "Backend",
    items: ["Node.js", ".NET", "Python"],
  },
  {
    label: "API Architecture",
    items: ["Microservices", "REST", "GraphQL"],
  },
  {
    label: "Mobile",
    items: ["React Native", "Cross-Platform Applications"],
  },
  {
    label: "Data",
    items: [
      "PostgreSQL",
      "MySQL",
      "DynamoDB",
      "Elasticsearch",
      "Cassandra",
      "Supabase",
      "Vector Databases",
    ],
  },
  {
    label: "Cloud & DevOps",
    items: [
      "AWS",
      "Microsoft Azure",
      "Docker",
      "Kubernetes",
      "Terraform",
      "CI/CD",
      "GitHub Actions",
    ],
  },
];

export const TechnologyEcosystem = () => {
  return (
    <section
      data-testid={TID.technologyEcosystem}
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-8 bg-[#FF5F1F]" />
            <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.25em] text-[#FF5F1F]">
              Engineering Ecosystem
            </span>
          </div>
          <h2 className="font-headings text-4xl md:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05] text-white">
            Modern Technology. <span className="text-zinc-500">Selected for the Product, Not the Trend.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-zinc-400 max-w-2xl leading-relaxed">
            We work across modern application development, AI engineering, cloud platforms, data
            systems, mobile products, enterprise technologies, and DevOps.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {CATEGORIES.map((cat, ci) => (
            <motion.div
              key={ci}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: ci * 0.05 }}
              className="bg-[#0A0A0A] p-6 md:p-8"
            >
              <div className="flex items-center gap-2 mb-5">
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FF5F1F]">
                  /{String(ci + 1).padStart(2, "0")}
                </span>
                <h3 className="font-headings text-lg md:text-xl font-bold text-white tracking-tight">
                  {cat.label}
                </h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {cat.items.map((it, i) => (
                  <span
                    key={i}
                    className="font-mono text-[11px] md:text-xs px-3 py-1.5 border border-white/10 bg-white/[0.02] text-zinc-300 hover:border-[#FF5F1F] hover:text-[#FF5F1F] transition-colors cursor-default"
                  >
                    {it}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
